import React from "react";
import { connect } from "react-redux";

import FullPageModal from "components/modals/FullPageModal";
import { ACCOUNT_TASK_MODAL } from "components/modals";
import AccountTaskForm from "./AccountTaskForm";
import { activeTaskSelector } from "../../../../reducers";

const AccountTaskModal = ({ activeTask }) => {
  return (
    <FullPageModal modalType={ACCOUNT_TASK_MODAL} style={{ content: { overflow: "visible" } }}>
      <AccountTaskForm record={activeTask} />
    </FullPageModal>
  );
};

const mapStateToProps = state => {
  return {
    activeTask: activeTaskSelector(state) || {},
  };
};

export default connect(mapStateToProps)(AccountTaskModal);
